// extracted by mini-css-extract-plugin
export var fadeInOut = "_3c-3";
export var icon = "_3c-4";
export var savedIndicator = "_3c-2";
export var savingIndicator = "_3c-0";
export var spin = "_3c-1";